import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'
import { CustomerUpdateInput } from 'lib/graphql/storefront'

const initialState: CustomerUpdateInput = {
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  corporationName: '',
  address: {
    countryCode: null,
    prefectureCode: null,
    zip: '',
    city: '',
    address1: '',
    address2: '',
  },
}

// Slice
const CustomerUpdateSlice = createSlice({
  name: 'customerUpdate',
  initialState,
  reducers: {
    setCustomerUpdate: (state, action: PayloadAction<CustomerUpdateInput>) => {
      const { payload } = action
      state.address = { ...state.address, ...payload.address }
      state.email = payload.email
      state.firstName = payload.firstName
      state.lastName = payload.lastName
      state.phone = payload.phone
      state.corporationName = payload.corporationName
    },
  },
})

// Selectors
export const getCustomerInputSelector = (
  state: RootState
): CustomerUpdateInput => state.customerUpdate

// Actions
export const { setCustomerUpdate } = CustomerUpdateSlice.actions

// Reducers
export default CustomerUpdateSlice.reducer
